// defs
import { AppState, IHeaderOptions } from "./types";

// helpers
import { APP_CONTEXT } from "shared/constants/index";

// action types
export const ActionTypes = {
    SET_HEADER_OFFER: "app/set-header-offer",
    FETCH_HEADER_OFFER: "app/fetch-header-offer",
    FETCH_HEADER_OFFER_FAILED: "app/fetch-header-offer-failed",
    FETCH_MENU_PROGRESS: "app/fetch_menu_progress",
    FETCH_MENU_SUCCESS: "app/fetch_menu_success",
    FETCH_MENU_FAILED: "app/fetch_menu_failed",
    FETCH_USER_PROGRESS: "app/fetch_user_progress",
    FETCH_USER_SUCCESS: "app/fetch_user_success",
    FETCH_USER_FAILED: "app/fetch_user_failed",
    UPDATE_CART_COUNT: "app/update_cart_count",
    INCREMENT_CART_COUNT: "app/increment_cart_count",
    UPDATE_CUSTOMER_DATA: "app/update_customer_data",
    UPDATE_CUSTOMER_DETAILS: "app/update_customer_details",
    SET_SSR_HEADERS: "app/set_ssr_headers",
    SET_RESPONSE_CODE: "app/set_response_code",
    SET_HEADER_OPTIONS: "app/set_header_options",
    RESET_HEADER_OPTIONS: "app/reset_header_options",
    SET_IN_PROGRESS: "app/set-in-progress",
    SET_HEADER_VISIBILITY: "app/set_header_visibility",
    SET_WEB_APP_TYPE: "app/set_web_app_type",
    SHOW_LOGIN_OPTIONS: "app/show_login_options",
    SET_APP_SEARCH_TERM: "app/set_app_search_term",
    REDIRECT: "app/redirect",
};

// actions
export const updateAppCartCount = (count: number) => ({
    type: ActionTypes.UPDATE_CART_COUNT,
    payload: count,
});

export const incrementAppCartCount = (payload: number) => ({
    type: ActionTypes.INCREMENT_CART_COUNT,
    payload,
});

export const updateAppUser = (user: AppState["user"]) => ({
    type: ActionTypes.UPDATE_CUSTOMER_DATA,
    payload: user,
});

export const updateStatusCode = (statusCode: number) => ({
    type: ActionTypes.SET_RESPONSE_CODE,
    payload: statusCode,
});

export const setHeaderOptions = (payload: IHeaderOptions) => ({
    type: ActionTypes.SET_HEADER_OPTIONS,
    payload,
});

export const resetHeaderOptions = () => ({
    type: ActionTypes.RESET_HEADER_OPTIONS,
});

export const setInProgress = (inProgress: boolean) => ({
    type: ActionTypes.SET_IN_PROGRESS,
    payload: inProgress,
});

export const showHeader = () => ({
    type: ActionTypes.SET_HEADER_VISIBILITY,
    payload: true,
});

export const hideHeader = () => ({
    type: ActionTypes.SET_HEADER_VISIBILITY,
    payload: false,
});

export const setWebAppType = (value: APP_CONTEXT) => ({
    type: ActionTypes.SET_WEB_APP_TYPE,
    payload: value,
});

export const updateCustomerDetails = (user: AppState["user"]["customerData"]) => ({
    type: ActionTypes.UPDATE_CUSTOMER_DETAILS,
    payload: user,
});

export const setAppSearchTerm = (value: string) => ({
    type: ActionTypes.SET_APP_SEARCH_TERM,
    payload: value,
});

export const redirect = (value: string) => ({
    type: ActionTypes.REDIRECT,
    payload: value,
});
